
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'สร้างแดชบอร์ด',
	'dashboard': 'แดชบอร์ด',
	'dashboardTemplate': 'เท็มเพลตแดชบอร์ด',
	'createAV': 'สร้าง',
	'createAvEditNameLabel': '1. ตั้งชื่อมุมมองของคุณ',
	'createAvSelectTemplateLabel': '2. เลือกเท็มเพลต',
	'tabLayoutLabel': 'เท็มเพลตแบบแท็บ',
	'infographicsLayoutLabel': 'เท็มเพลตแบบอินโฟกราฟิก',
	'singlePageLayoutLabel': 'เท็มเพลตเพจเดียว',
	'customLayoutLabel': 'เท็มเพลตแบบกำหนดเอง',
	'freeformTemplate': 'รูปแบบอิสระ',
	'freeformTemplateDesc': 'วิชวลไลเซชันในโครงร่างแบบอิสระจะปรากฏตามที่คุณปรับขนาดและวางไว้ในมุมมอง โดยไม่คำนึงถึงขนาดของหน้าจอ ในโครงร่างแบบอื่น ขนาดและตำแหน่งของการแสดงให้เห็นภาพจะปรับเพื่อให้พอดีกับหน้าจอ',
	'NoTemplate': 'รูปทรงอิสระ',
	'Template1': 'ว่าง',
	'Template2': 'หัวเรื่อง 1 คูณ 2',
	'Template3': '2 เหนือ 1',
	'Template4': '4 เหนือ 1',
	'Template5': 'ส่วนท้าย 1 คูณ 2',
	'Template6': '3 ข้าง 1 เหนือ 1',
	'Template7': '4 ข้าง 3 เหนือ 1',
	'Template8': '2 เหนือ 3 คูณ 2',
	'Template9': '2 คูณ 2',
	'Template10': '1 คูณ 2 ข้าง 2 คูณ 2 เหนือ 1',
	'Template11': '3 คูณ 1 เหนือ 1 คูณ 2',
	'Template12': '2 เหนือ 1 ข้าง 1 คูณ 2',
	'Template13': 'หนึ่งข้าง 1 คูณ 2 ข้าง 1 คูณ 4',
	'Template22': '1 เหนือ 2 คูณ 2',
	'Template14': '1 ข้าง 1',
	'Template15': '1 เหนือ 1 ข้าง 1',
	'Template16': '1 ข้าง 1 เหนือ 1',
	'Template17': '1 เหนือ 1 ข้าง 1 เหนือ 1',
	'Template18': '1 เหนือ 1 ข้าง 1',
	'Template19': '1 เหนือ 2 ข้าง 1',
	'Template20': '1 เหนือ 2 คูณ 1',
	'Template21': '1 เหนือ 1 เหนือ 2 คูณ 1',
	'Template23': 'ว่างพร้อมดร็อปโซน',
	'Infographics1': 'ว่าง',
	'Infographics2': '4 แถว',
	'Infographics3': '4 แถวที่มีส่วนหัว',
	'Infographics4': '2 คูณ 4',
	'Infographics5': 'การแสดงผลด้านบนขนาดใหญ่ด้วย 2 คูณ 2',
	'Infographics6': '2 คูณ 4 ที่มีช่องว่างแนวตั้ง',
	'Infographics7': '2 คูณ 4 เหลื่อมกัน',
	'Infographics8': 'สนามเทนนิส',
	'Infographics9': '3 คูณ 4',
	'Infographics10': '4 คูณ 8',
	'createAvDashboardLabel': 'โครงร่าง',
	'dashboard_template_save_success': 'บันทึกเท็มเพลตแดชบอร์ดแล้ว',
	'dashboard_template_prefix': 'เท็มเพลต: "%{name}"',
	'dashboard_template_filters_removed': 'ตัวกรองบนแคนวาสถูกลบออกแล้ว',
	'createAvTabLabel': 'แบบแท็บ',
	'createAvInfographicsLabel': 'อินโฟกราฟิก',
	'createAvSinglepageLabel': 'เพจเดี่ยว',
	'createAvCustomLabel': 'กำหนดเอง',
	'loadMoreLabel': 'โหลดเพิ่มเติม...',
	'backLabel': 'ย้อนกลับ',
	'addSourceLabel': 'เพิ่มแหล่งที่มา',
	'pinLabel': 'ปักหมุด',
	'errorLoadingDataSetMetaData': 'เกิดข้อผิดพลาดขึ้นขณะอ่านข้อมูลเมตา',
	'errorLoadingDataSets': 'มีข้อผิดพลาดเกิดขึ้นขณะโหลดรายการชุดข้อมูล',
	'errorLoadingDataSet': 'ไม่โหลดข้อมูลเมตาสำหรับชุดข้อมูล "%{datasetName}" โปรดติดต่อผู้ดูแลระบบของคุณสำหรับรายละเอียด',
	'okButton': 'ตกลง',
	'createButton': 'สร้าง',
	'cancelButton': 'ยกเลิก',
	'copyButton': 'คัดลอก',
	'selectTemplateLabel': 'เลือกเท็มเพลต',
	'createBoardTitle': 'สร้างแดชบอร์ด',
	'createBoardSubtitle': 'เลือกเท็มเพลตสำหรับแดชบอร์ดของคุณ',
	'noSourcesSelectedLabel': 'ไม่ได้เลือกแหล่งที่มา',
	'find_label': 'ค้นหา',
	'noDashboardFound': 'แดชบอร์ดไม่สามารถดึงข้อมูลได้ เนื่องจากไม่มีข้อมูลอยู่แล้ว หรือคุณมี privileges ไม่เพียงพอในการดูข้อมูล',
	'errorLabel': 'ข้อผิดพลาด',
	'defaultName': 'แดชบอร์ดใหม่',
	'noDashboardCapability': 'คุณไม่มีความสามารถในการรันแอ็พพลิเคชันแดชบอร์ด',
	'noDashboardPermission': 'คุณไม่มีสิทธิที่เพียงพอในการดูแดชบอร์ดนี้',
	'sourceNotFound': 'เราไม่สามารถโหลดวิชวลไลเซชันได้ เนื่องจากแหล่งข้อมูลที่เชื่อมโยง "%{sourceName}" ไม่พร้อมใช้งาน',
	'cmDuplicateName': 'มีรายการที่มีชื่อนี้อยู่แล้ว ลองชื่ออื่น',
	'cmEmptySelection': 'แดชบอร์ดถูกลบออกแล้ว พยายามบันทึกเป็นแดชบอร์ดใหม่',
	'propTheme': 'ธีมภาพ',
	'legacyThemeLabel': 'ดั้งเดิม',
	'carbonGrey10Label': 'คาร์บอน X สีจาง',
	'carbonGrey100Label': 'คาร์บอน X สีเข้ม',
	'titleTextLabel': 'หัวเรื่อง',
	'titleSmallTextLabel': 'หัวเรื่องขนาดเล็ก',
	'subtitleTextLabel': 'หัวเรื่องย่อย',
	'bodyTextLabel': 'เนื้อความ',
	'bodySmallTextLabel': 'เนื้อเรื่องขนาดเล็ก',
	'captionTextLabel': 'คำบรรยาย',
	'quoteTextLabel': 'การอ้างอิง',
	'quoteSmallTextLabel': 'การอ้างอิงขนาดเล็ก',
	'responsiveTextLabel': 'ปรับขนาดอัตโนมัติ',
	'mediaWidgetLabel': 'สื่อ',
	'webpageWidgetLabel': 'เว็บเพจ',
	'imageWidgetLabel': 'อิมเมจ',
	'textWidgetLabel': 'ข้อความ',
	'notebookWidgetLabel': 'โน้ตบุ๊ก',
	'multipurposeWidgetLabel': 'เอนกประสงค์',
	'textPlaceHolder': 'คลิกเพื่อแก้ไขข้อความ',
	'titlePlaceHolder': 'คลิกเพื่อแก้ไขชื่อเรื่อง',
	'toggleEditModeLabel': 'สลับเพื่อแก้ไข',
	'togglePreviewModeLabel': 'สลับเพื่อแสดงตัวอย่าง',
	'editDashboardCoachMarkTitle': 'แก้ไขแดชบอร์ด',
	'editDashboardCoachMarkContents': 'คลิกไอคอนดินสอเพื่อแก้ไขแดชบอร์ด',
	'addDataCoachMarkTitle': 'เพิ่มข้อมูล',
	'addDataDashboardCoachMarkContents': 'ลากและดร็อปข้อมูจากพาเนลข้อมูลบนแดชบอร์ดของคุณ',
	'pageSelectWarning': 'โปรดเลือกแท็บ',
	'screenshot_label': 'แดชบอร์ด %{title}',
	'screenshot_label_tab': 'แท็บ %{tabName} ของแดชบอร์ด %{title}',
	'dataAssetPropertiesLabel': 'คุณสมบัติวิชวลไลเซชัน',
	'modelFilter': 'ตัวกรอง',
	'invertSelectionToolTip': 'กลับการเลือกตัวกรอง',
	'clearFilterValueToolTip': 'เคลียร์ค่าตัวกรอง',
	'invertFilterSelection': 'กลับ',
	'clearTextFilterValue': 'เคลียร์',
	'filterConditionLabel': 'เงื่อนไขตัวกรอง',
	'applyFilter': 'ใช้ตัวกรอง',
	'itemCountText': '%{itemCount} ไอเท็มถูกเลือกไว้',
	'itemExcludeCountText': '%{itemCount} ไอเท็มที่ไม่รวม',
	'moreMembers': 'แสดงเพิ่มเติม...',
	'searchHierarchyMembers': 'ใช้การค้นหาเพื่อค้นหาสมาชิก...',
	'propHideEmpty': 'ซ่อนที่ว่าง',
	'propColorOrder': 'ลำดับของสี',
	'propElementColor': 'สีอิลิเมนต์ของวิชวลไลเซชัน',
	'propLineColor': 'สีของเส้น',
	'propLineAndSymbolColor': 'สีของเส้นและสัญลักษณ์',
	'propColumnColor': 'สีคอลัมน์',
	'propBarColor': 'สีของแท่ง',
	'propWordColor': 'สีของคำ',
	'propAreaColor': 'สีของพื้นที่',
	'propRadialbarColor': 'สีของแท่งตามแนวรัศมี',
	'propColorPalettes': 'ถาดสี',
	'propDashboardColorPalette': 'พาเล็ตแดชบอร์ดปัจจุบัน',
	'propNewDashboardPaletteLabel': 'สร้างพาเล็ตแดชบอร์ดที่กำหนดเอง',
	'propDashboardChangePaletteLink': 'เปลี่ยนพาเล็ตแดชบอร์ด',
	'propHideLeafNode': 'ซ่อนเลเบลส่วนนำ',
	'propOpacity': 'ความทึบแสง',
	'propOpacityDescription': 'ทำให้อ็อบเจ็กต์มีความทึบแสงมากขึ้น หรือน้อยลง พิมพ์ค่าระหว่าง 0 ถึง 100',
	'addATab': 'เพิ่มแท็บใหม่',
	'propFredIsRed': 'ความสอดคล้องกันของสี',
	'areaChartCaption': 'พื้นที่',
	'areaChartDataSlot_categoriesLabel': 'เลเบลแกน',
	'areaChartDataSlot_valuesLabel': 'ค่า',
	'areaChartProp_colorPaletteLabel': 'ถาดสี',
	'areaChartProp_lineColorLabel': 'สีของพื้นที่',
	'areaChartProp_interpolationLabel': 'เส้นแบบเรียบ',
	'areaChartProp_interpolationDescription': 'เส้นที่เชื่อมต่อจุดข้อมูลเป็นเส้นโค้ง',
	'areaChartProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'areaChartProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'areaChartProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'areaChartProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'areaChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'areaChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'areaChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'areaChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'barChartCaption': 'แท่ง',
	'barChartDataSlot_categoriesLabel': 'เลเบลแกน',
	'barChartDataSlot_valuesLabel': 'ค่า',
	'barChartProp_colorPaletteLabel': 'ถาดสี',
	'barChartProp_elementColorLabel': 'สีของแท่ง',
	'barChartProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'barChartProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'barChartProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'barChartProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'barChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'barChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'barChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'barChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'columnChartCaption': 'คอลัมน์',
	'columnChartDataSlot_categoriesLabel': 'เลเบลแกน',
	'columnChartDataSlot_valuesLabel': 'ค่า',
	'columnChartProp_colorPaletteLabel': 'ถาดสี',
	'columnChartProp_elementColorLabel': 'สีคอลัมน์',
	'columnChartProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'columnChartProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'columnChartProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'columnChartProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'columnChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'columnChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'columnChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'columnChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'bubbleChartCaption': 'บับเบิล',
	'bubbleChartDataSlot_xAxisLabel': 'แกนแนวนอน',
	'bubbleChartDataSlot_yAxisLabel': 'แกนแนวตั้ง',
	'bubbleChartDataSlot_sizeLabel': 'ขนาดตาม',
	'bubbleChartDataSlot_colorLabel': 'สีตาม',
	'bubbleChartProp_colorPaletteLabel': 'ถาดสี',
	'bubbleChartProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'bubbleChartProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'bubbleChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'bubbleChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'bubbleChartProp_hideLegendLabel': 'ซ่อนคำอธิบายสัญลักษณ์',
	'bubbleChartProp_hideLegendDescription': 'ซ่อนคำอธิบายสัญลักษณ์',
	'bubbleChartProp_legendPositionLabel': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'lineChartCaption': 'เส้น',
	'lineChartDataSlot_categoriesLabel': 'เลเบลแกน',
	'lineChartDataSlot_valuesLabel': 'ค่า',
	'lineChartProp_colorPaletteLabel': 'ถาดสี',
	'lineChartProp_lineColorLabel': 'สีของเส้นและสัญลักษณ์',
	'lineChartProp_symbolShapeLabel': 'รูปทรงสัญลักษณ์',
	'lineChartProp_hideSymbolsLabel': 'ซ่อนสัญลักษณ์',
	'lineChartProp_hideSymbolsDescription': 'ซ่อนสัญลักษณ์',
	'lineChartProp_hideDataLinesLabel': 'ซ่อนเส้น',
	'lineChartProp_hideDataLinesDescription': 'ซ่อนเส้น',
	'lineChartProp_interpolationLabel': 'เส้นแบบเรียบ',
	'lineChartProp_interpolationDescription': 'เส้นที่เชื่อมต่อจุดข้อมูลเป็นเส้นโค้ง',
	'lineChartProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'lineChartProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'lineChartProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'lineChartProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'lineChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'lineChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'lineChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'lineChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'packedBubbleChart1CatCaption': 'บับเบิลที่แพ็ก',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'หมวดหมู่',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'ขนาดตาม',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'ถาดสี',
	'packedBubbleChart1CatProp_elementColorLabel': 'สีของบับเบิล',
	'packedBubbleChart1CatProp_hideLabelLabel': 'ซ่อนเลเบล',
	'packedBubbleChart1CatProp_hideValueLabel': 'ซ่อนค่า',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'heatChartCaption': 'ความร้อน',
	'heatChartDataSlot_valuesLabel': 'ความร้อนตาม',
	'heatChartDataSlot_xAxisLabel': 'แกนแนวนอน',
	'heatChartDataSlot_yAxisLabel': 'แกนแนวตั้ง',
	'heatChartProp_colorPaletteLabel': 'ถาดสี',
	'heatChartProp_heatScalePaletteLabel': 'ลำดับของสี',
	'heatChartProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'heatChartProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'heatChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'heatChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'heatChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'heatChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'heatChartProp_hideLegendLabel': 'ซ่อนคำอธิบายสัญลักษณ์',
	'heatChartProp_hideLegendDescription': 'ซ่อนคำอธิบายสัญลักษณ์',
	'heatChartProp_legendPositionLabel': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'pieChartCaption': 'วงกลม',
	'pieChartDataSlot_categoriesLabel': 'หมวดหมู่',
	'pieChartDataSlot_valuesLabel': 'ค่า',
	'pieChartProp_colorPaletteLabel': 'ถาดสี',
	'pieChartProp_hideRadialValueLabel': 'ซ่อนค่า',
	'pieChartProp_pieAsDonutLabel': 'แสดงเป็นแผนภูมิโดนัท',
	'pieChartProp_pieAsDonutDescription': 'แสดงเป็นแผนภูมิโดนัท',
	'pieChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'pieChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'pieChartProp_hideLegendLabel': 'ซ่อนคำอธิบายสัญลักษณ์',
	'pieChartProp_hideLegendDescription': 'ซ่อนคำอธิบายสัญลักษณ์',
	'pieChartProp_legendPositionLabel': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'map1measureCaption': 'แม็พ',
	'map1measureDataSlot_categoriesLabel': 'ภูมิภาค',
	'map1measureDataSlot_valuesLabel': 'ความร้อนของภูมิภาค',
	'map1measureProp_colorPaletteLabel': 'ถาดสี',
	'map1measureProp_heatScalePaletteLabel': 'ลำดับของสี',
	'map1measureProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'map1measureProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'map1measureProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'map1measureProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'map1measureProp_hideLegendLabel': 'ซ่อนคำอธิบายสัญลักษณ์',
	'map1measureProp_hideLegendDescription': 'ซ่อนคำอธิบายสัญลักษณ์',
	'map1measureProp_legendPositionLabel': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'radialChartCaption': 'รัศมี',
	'radialChartDataSlot_categoriesLabel': 'หมวดหมู่',
	'radialChartDataSlot_valuesLabel': 'ค่า',
	'radialChartProp_colorPaletteLabel': 'ถาดสี',
	'radialChartProp_elementColorLabel': 'สีของแท่งตามแนวรัศมี',
	'radialChartProp_hideRadialTitleLabel': 'ซ่อนหัวเรื่อง',
	'radialChartProp_hideRadialValueLabel': 'ซ่อนค่า',
	'radialChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'radialChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'radialChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'radialChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'pointChart1catCaption': 'จุด',
	'pointChart1catDataSlot_valuesLabel': 'ค่า',
	'pointChart1catDataSlot_categoriesLabel': 'เลเบลแกน',
	'pointChart1catProp_colorPaletteLabel': 'ถาดสี',
	'pointChart1catProp_elementColorLabel': 'สีของรูปทรง',
	'pointChart1catProp_symbolShapeLabel': 'รูปทรงสัญลักษณ์',
	'pointChart1catProp_symbolFillLabel': 'รูปทรงที่เติม',
	'pointChart1catProp_symbolFillDescription': 'แสดงสีที่เติมสำหรับสัญลักษณ์',
	'pointChart1catProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'pointChart1catProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'pointChart1catProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'pointChart1catProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'pointChart1catProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'pointChart1catProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'scatterPlotChartNoCatCaption': 'แผนภาพกระจาย',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'แกนแนวนอน',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'แกนแนวตั้ง',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'ถาดสี',
	'scatterPlotChartNoCatProp_elementColorLabel': 'สีของอิลิเมนต์',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'รูปทรงสัญลักษณ์',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'รูปทรงที่เติม',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'แสดงสีที่เติมสำหรับสัญลักษณ์',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'radialBarChartCaption': 'แท่งตามแนวรัศมี',
	'radialBarChartDataSlot_categoriesLabel': 'หมวดหมู่',
	'radialBarChartDataSlot_valuesLabel': 'ค่า',
	'radialBarChartProp_colorPaletteLabel': 'ถาดสี',
	'radialBarChartProp_elementColorLabel': 'สีของแท่งตามแนวรัศมี',
	'radialBarChartProp_hideRadialTitleLabel': 'ซ่อนหัวเรื่อง',
	'radialBarChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'radialBarChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'radialBarChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'radialBarChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'lineColumnComboChartCaption': 'เส้นและคอลัมน์',
	'lineColumnComboChartDataSlot_categoryLabel': 'เลเบลแกน',
	'lineColumnComboChartDataSlot_lineValueLabel': 'ค่าเส้น',
	'lineColumnComboChartDataSlot_columnValueLabel': 'ค่าคอลัมน์',
	'lineColumnComboChartProp_colorPaletteLabel': 'ถาดสี',
	'lineColumnComboChartProp_elementColorLabel': 'สีคอลัมน์',
	'lineColumnComboChartProp_lineColorLabel': 'สีของเส้นและสัญลักษณ์',
	'lineColumnComboChartProp_symbolShapeLabel': 'รูปทรงสัญลักษณ์',
	'lineColumnComboChartProp_hideSymbolsLabel': 'ซ่อนสัญลักษณ์',
	'lineColumnComboChartProp_hideSymbolsDescription': 'ซ่อนสัญลักษณ์',
	'lineColumnComboChartProp_hideDataLinesLabel': 'ซ่อนเส้น',
	'lineColumnComboChartProp_hideDataLinesDescription': 'ซ่อนเส้น',
	'lineColumnComboChartProp_interpolationLabel': 'เส้นแบบเรียบ',
	'lineColumnComboChartProp_interpolationDescription': 'เส้นที่เชื่อมต่อจุดข้อมูลเป็นเส้นโค้ง',
	'lineColumnComboChartProp_hideGridLinesLabel': 'ซ่อนเส้นกริด',
	'lineColumnComboChartProp_hideGridLinesDescription': 'ซ่อนเส้นกริด',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'ซ่อนเลเบลหัวเรื่องแกน',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'ซ่อนหัวเรื่องของแกน',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'lineColumnComboChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'lineColumnComboChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'lineColumnComboChartProp_hideLegendLabel': 'ซ่อนคำอธิบายสัญลักษณ์',
	'lineColumnComboChartProp_hideLegendDescription': 'ซ่อนคำอธิบายสัญลักษณ์',
	'lineColumnComboChartProp_legendPositionLabel': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'summaryCaption': 'ยอดรวม',
	'areaName': 'พื้นที่',
	'areaDescription': 'พื้นที่',
	'areaDataSlot_colorLabel': 'สีตาม',
	'areaDataSlot_valuesLabel': 'ค่า',
	'areaDataSlot_categoriesLabel': 'เลเบลแกน',
	'bubbleName': 'บับเบิล',
	'bubbleDescription': 'บับเบิล',
	'bubbleDataSlot_yAxisLabel': 'แกนแนวตั้ง',
	'bubbleDataSlot_xAxisLabel': 'แกนแนวนอน',
	'bubbleDataSlot_sizeLabel': 'ขนาดตาม',
	'bubbleDataSlot_colorLabel': 'สีตาม',
	'clusterBarName': 'แท่ง',
	'clusterBarDescription': 'แท่ง',
	'clusterBarDataSlot_colorLabel': 'สีตาม',
	'clusterBarDataSlot_valuesLabel': 'ค่า',
	'clusterBarDataSlot_categoriesLabel': 'เลเบลแกน',
	'clusterBarDataSlot_valuesRepeatingLabel': 'ค่า',
	'clusterColumnName': 'คอลัมน์',
	'clusterColumnDescription': 'คอลัมน์',
	'clusterColumnDataSlot_colorLabel': 'สีตาม',
	'clusterColumnDataSlot_valuesLabel': 'ค่า',
	'clusterColumnDataSlot_categoriesLabel': 'เลเบลแกน',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'ค่า',
	'clusterLineName': 'เส้น',
	'clusterLineDescription': 'เส้น',
	'clusterLineDataSlot_colorLabel': 'สีตาม',
	'clusterLineDataSlot_valuesLabel': 'แกนแนวตั้ง',
	'clusterLineDataSlot_categoriesLabel': 'แกนแนวนอน',
	'clusterLineDataSlot_valuesRepeatingLabel': 'ค่า',
	'gridName': 'กริด',
	'gridDescription': 'กริด',
	'gridDataSlot_grid_colsLabel': 'คอลัมน์',
	'heatName': 'ความร้อน',
	'heatDescription': 'ความร้อน',
	'heatDataSlot_yAxisLabel': 'แกนแนวตั้ง',
	'heatDataSlot_xAxisLabel': 'แกนแนวนอน',
	'heatDataSlot_valuesLabel': 'ความร้อนตาม',
	'lineColumnComboName': 'เส้นและคอลัมน์',
	'lineColumnComboDescription': 'เส้นและคอลัมน์',
	'lineColumnComboDataSlot_lineValueLabel': 'ค่าเส้น',
	'lineColumnComboDataSlot_categoryLabel': 'เลเบลแกน',
	'lineColumnComboDataSlot_columnValueLabel': 'ค่าคอลัมน์',
	'mapName': 'แผนที่สืบทอด',
	'mapDescription': 'แผนที่สืบทอด',
	'mapDataSlot_sizeLabel': 'ขนาดพอยต์',
	'mapDataSlot_valuesLabel': 'ความร้อนของภูมิภาค',
	'mapDataSlot_sizeHeatLabel': 'ความร้อนของพอยต์',
	'mapDataSlot_categoriesLabel': 'ภูมิภาค',
	'packedBubbleName': 'บับเบิลที่แพ็ก',
	'packedBubbleDescription': 'บับเบิลที่แพ็ก',
	'packedBubbleDataSlot_sizeLabel': 'ขนาดตาม',
	'packedBubbleDataSlot_colorLabel': 'สีตาม',
	'packedBubbleDataSlot_categoriesLabel': 'หมวดหมู่',
	'pieName': 'วงกลม',
	'pieDescription': 'วงกลม',
	'pieDataSlot_valuesLabel': 'ค่า',
	'pieDataSlot_categoriesLabel': 'หมวดหมู่',
	'playerName': 'เครื่องเล่นข้อมูล',
	'playerDescription': 'เครื่องเล่นข้อมูล',
	'playerDataSlot_categoriesLabel': 'เลเบลแกน',
	'pointName': 'จุด',
	'pointDescription': 'จุด',
	'pointDataSlot_colorLabel': 'สีตาม',
	'pointDataSlot_valuesLabel': 'ค่า',
	'pointDataSlot_categoriesLabel': 'เลเบลแกน',
	'radialName': 'รัศมี',
	'radialDescription': 'รัศมี',
	'radialDataSlot_valuesLabel': 'ค่า',
	'radialDataSlot_maxSizeLabel': 'ค่าสูงสุด',
	'radialDataSlot_categoriesLabel': 'หมวดหมู่',
	'radialBarName': 'แท่งตามแนวรัศมี',
	'radialBarDescription': 'แท่งตามแนวรัศมี',
	'radialBarDataSlot_valuesLabel': 'ค่า',
	'radialBarDataSlot_categoriesLabel': 'หมวดหมู่',
	'scatterPlotName': 'แผนภาพกระจาย',
	'scatterPlotDescription': 'แผนภาพกระจาย',
	'scatterPlotDataSlot_yAxisLabel': 'แกนแนวตั้ง',
	'scatterPlotDataSlot_xAxisLabel': 'แกนแนวนอน',
	'scatterPlotDataSlot_colorLabel': 'สีตาม',
	'scatterPlotDataSlot_categoriesLabel': 'จุด',
	'stackedBarName': 'แท่งแบบสแต็ก',
	'stackedBarDescription': 'แท่งแบบสแต็ก',
	'stackedBarDataSlot_colorLabel': 'สีตาม',
	'stackedBarDataSlot_valuesLabel': 'ค่า',
	'stackedBarDataSlot_categoriesLabel': 'เลเบลแกน',
	'stackedBarDataSlot_valuesRepeatingLabel': 'ค่า',
	'stackedColumnName': 'คอลัมน์แบบสแต็ก',
	'stackedColumnDescription': 'คอลัมน์แบบสแต็ก',
	'stackedColumnDataSlot_colorLabel': 'สีตาม',
	'stackedColumnDataSlot_valuesLabel': 'ค่า',
	'stackedColumnDataSlot_categoriesLabel': 'เลเบลแกน',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'ค่า',
	'summaryChartName': 'ยอดรวม',
	'summaryChartDescription': 'ยอดรวม',
	'summaryChartDataSlot_valuesLabel': 'ค่า',
	'treeMapName': 'แม็พแผนผัง',
	'treeMapDescription': 'แม็พแผนผัง',
	'treeMapDataSlot_colorLabel': 'ความร้อนตาม',
	'treeMapDataSlot_valuesLabel': 'ขนาดตาม',
	'treeMapDataSlot_categoriesLabel': 'ระดับหนึ่ง',
	'treeMapDataSlot_level3Label': 'ระดับสาม',
	'treeMapDataSlot_level2Label': 'ระดับสอง',
	'wordCloudName': 'Word cloud',
	'wordCloudDescription': 'Word cloud',
	'wordCloudDataSlot_colorLabel': 'สีตาม',
	'wordCloudDataSlot_scaleLabel': 'ขนาดตาม',
	'wordCloudDataSlot_wordLabel': 'คำ',
	'treeMap1Cat1MeasureChartCaption': 'แม็พแผนผัง',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'ระดับหนึ่ง',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'ขนาดตาม',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'ถาดสี',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'ถาดสี',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'ถาดสี',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'ถาดสี',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'ถาดสี',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'ถาดสี',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'ซ่อนคำอธิบายสัญลักษณ์',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'ซ่อนคำอธิบายสัญลักษณ์',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'wordChart1Cat1MeasureCaption': 'Word cloud',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'คำ',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'ขนาดตาม',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'ถาดสี',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'สีของคำ',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'รักษาสเกลของแกน',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'แสดงค่าต่ำสุดและค่าสูงสุดบนแกนเสมอ',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'ซ่อนที่ว่าง',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'ซ่อนหมวดหมู่ที่ไม่มีค่าซึ่งเชื่อมโยง',
	'missingDataSetData': 'ข้อมูลสำหรับชุดข้อมูลนี้ไม่พร้อมใช้งาน รีเฟรชชุดข้อมูล หรือติดต่อผู้ดูแลระบบของคุณสำหรับการเข้าถึงแหล่งข้อมูล',
	'hideShowSummaries': 'ซ่อนการแสดงสรุป',
	'crosstabName': 'อ้างอิงไขว้',
	'value_is_not_available': 'ไม่ระบุ',
	'swapRowsAndColumns': 'สลับแถวและคอลัมน์',
	'NoPinsCollected': 'ไม่มีวิชวลไลเซชันที่ปักหมุดไว้',
	'pinSearchOld': 'ค้นหาการปักหมุดของฉัน',
	'pinDeletedToast': 'การปักหมุดถูกลบออกแล้ว',
	'pinAddedToast': 'เพิ่มการปักหมุดเข้ากับการปักหมุดของฉันสำเร็จแล้ว',
	'pinRetrieveError': 'เราไม่สามารถดึงการปักหมุดอย่างน้อยหนึ่งรายการ โปรดลองอีกครั้งภายหลัง',
	'pinErrorTitle': 'ข้อผิดพลาดในการปักหมุด',
	'pinRemove': 'ลบการปักหมุด',
	'deletePin': 'ลบการปักหมุด',
	'dataset_time': 'time',
	'dataset_date': 'วันที่',
	'dataset_location': 'ตำแหน่ง',
	'dataset_number': 'ตัวเลข',
	'dataset_text': 'ข้อความ',
	'widgetConditionalFormatLabel': 'สลับตัวควบคุมรูปแบบแบบมีเงื่อนไข',
	'deletePinConfirmationMessage': 'คุณแน่ใจว่าต้องการลบพินนี้หรือไม่ การดำเนินการนี้ไม่สามารถเลิกทำได้',
	'deletePinConfirm': 'ยืนยันการลบ',
	'pinDeleteError': 'เราไม่สามารถลบการปักหมุดอย่างน้อยหนึ่งรายการ โปรดลองอีกครั้งภายหลัง',
	'metadataPickerTitle': 'สร้างชุดข้อมูล',
	'moreTitle': 'เพิ่มขึ้น',
	'remove_slider_handle': 'ลบแฮนเดิล',
	'missingFiltering': 'คอลัมน์หายไป:',
	'unSupportedPromptType': 'สถานการณ์จำลองพร้อมต์ไม่ได้รับการสนับสนุน',
	'preAggregateLabel': 'ใช้ค่าพร้อมต์จากแหล่งข้อมูล',
	'postAggregateLabel': 'ใช้ค่าพร้อมต์ในรายงาน',
	'preAggregateText': 'ช่วงใช้ค่าในแหล่งข้อมูล ไม่ใช่ค่าที่ปรากฏในแดชบอร์ด',
	'tabName_general': 'ทั่วไป', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'รายละเอียด',
	'tabName_textDetails': 'รายละเอียดของข้อความ', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'รายละเอียดของสื่อบันทึก', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'รายละเอียดของเว็บเพจ', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'รายละเอียดของรูปภาพ', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'วิชวลไลเซชัน',
	'sectionName_canvas': 'ภาพวาด',
	'sectionName_colorsAndThemes': 'สีและธีม',
	'colorsAndThemes_legacyWarning': 'แดชบอร์ดปัจจุบันกำลังใช้ธีมจากรีลีสก่อนหน้า การเปลี่ยนธีมและการบันทึกแดชบอร์ดจะลบการเข้าถึงพาเล็ตของธีมก่อนหน้านี้อย่างถาวร',
	'sectionName_details': 'รายละเอียด',
	'sectionName_positionAndStyle': 'ตำแหน่ง & สไตล์',
	'sectionName_appearance': 'ลักษณะที่ปรากฏ', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'ขั้นสูง',
	'sectionName_layout': 'โครงร่าง', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'แท็บ',
	'sectionName_tabTitle': 'เลเบล',
	'sectionName_tabBackground': 'พื้นหลัง',
	'addDataSourceDialogTitle': 'เพิ่มแหล่งข้อมูล',
	'addDataSourceDialogButtonLabel': 'เพิ่ม',
	'shapesDoubleChevron': 'chevron คู่',
	'widgetsPanelTitle': 'วิดเจ็ต',
	'widgetsPanelBasicsTab': 'พื้นฐาน',
	'widgetsPanelImageLibraryTab': 'รูปภาพ',
	'widgetsPanelSectionStandard': 'มาตรฐาน',
	'widgetsPanelSectionAdvanced': 'ขั้นสูง',
	'widgetsPanelSectionShapes': 'รูปทรง',
	'customWidgetsTitle': 'วิดเจ็ตแบบกำหนดเอง',
	'filterItemCanvasMove': 'เพิ่มไปยังภาพวาด',
	'filterOverflowMenu_Global': 'โอเวอร์โฟลว์เมนูแท็บทั้งหมด',
	'filterOverflowMenu_Tab': 'โอเวอร์โฟลว์เมนูแท็บนี้',
	'filterOverflowMenu_Item': 'โอเวอร์โฟลว์เมนูตัวกรอง',
	'filterOverflowMenu_Single': 'โอเวอร์โฟลว์เมนู',
	'filterItemEdit': 'แก้ไขค่าตัวกรอง',
	'filterDeleteAllItems': 'ลบตัวกรองทั้งหมด',
	'filterClearAllItems': 'เคลียร์ตัวกรองทั้งหมด',
	'filterClearSelection': 'เคลียร์ตัวกรอง',
	'filterPlayerMode': 'แสดงเครื่องเล่น',
	'filterStaticMode': 'แสดงรายการ',
	'filterInvertSelection': 'กลับตัวกรอง',
	'filterIconLabel_Global': 'แท็บทั้งหมด',
	'filterIconLabel_Single': 'ตัวกรอง',
	'filterIconLabel_Tab': 'แท็บนี้',
	'filterIconTooltip_Global': 'แท็บทั้งหมด',
	'filterIconTooltip_Tab': 'แท็บนี้',
	'filterIconTooltip_Single': 'ตัวกรอง',
	'filterItemDelete': 'ลบตัวกรอง',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'ทุกสิ่งยกเว้น: %{from}-%{to}',
	'filterExcept': 'ยกเว้น %{values}',
	'filterAll': 'ทั้งหมด',
	'filterBlank': '(ว่าง)',
	'filterDisableRangeInvert': 'ไม่พร้อมใช้งานเมื่อคอลัมน์นี้อยู่ในตัวกรอง "แท็บทั้งหมด"',
	'filterDisableHierarchyInvert': 'ไม่พร้อมใช้งานเมื่อคอลัมน์นี้อยู่ในตัวกรองลำดับชั้น',
	'filterSelectedOfTotal': '%{selected} จาก %{totalMembers}',
	'filter_date_before': 'ก่อน %{to}',
	'filter_date_before_except': 'ไม่ก่อน %{to}',
	'filter_date_after': 'หลังจาก %{from}',
	'filter_date_after_except': 'ไม่หลังจาก %{from}',
	'filter_date_between': 'ระหว่าง %{from}-%{to}',
	'filter_date_between_except': 'ไม่ระหว่าง %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรองแท็บทั้งหมด',
	'filter_drag_and_drop_current_tab': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรองแท็บนี้',
	'filter_drag_and_drop_single_dock': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรอง',
	'errMsgFilterItemGenericTitle': 'ไม่สามารถโหลดค่าตัวกรองได้',
	'widgetChromeRotate': 'หมุน',
	'toolbarRegionLabel': 'แถบเครื่องมือ',
	'toolbarActionDelete': 'ลบ',
	'toolbarActionGroup': 'กลุ่ม',
	'toolbarActionUngroup': 'ยกเลิกกลุ่ม',
	'toolbarActionOrderToFront': 'ส่งไปด้านหน้า',
	'toolbarActionOrderToBack': 'ส่งไปด้าหลัง',
	'toolbarActionEditTitle': 'แก้ไขหัวเรื่อง',
	'toolbarActionWrapTitle': 'ตัดคำหัวเรื่อง',
	'toolbarActionPin': 'รวบรวม',
	'toolbarActionPinOld': 'ปักหมุด',
	'toolbarActionAlign': 'จัดตำแหน่ง',
	'alignWidgetLeft': 'ด้านซ้าย',
	'alignWidgetCenter': 'กึ่งกลาง',
	'alignWidgetRight': 'ด้านขวา',
	'alignWidgetTop': 'บน',
	'alignWidgetMiddle': 'กลาง',
	'alignWidgetBottom': 'ล่าง',
	'toolbarChangeVisualization': 'เปลี่ยนวิชวลไลเซชัน',
	'multipurposeHeader': 'เลือกชนิดของวิดเจ็ต',
	'multipurposePlaceholderText': 'เลือกหนึ่งในวิดเจ็ตเพื่อเริ่มต้นทำงาน',
	'live_label': 'แผนภูมิ',
	'filter_label': 'ตัวกรอง',
	'one_named_live': '%{name} แผนภูมิ',
	'one_named_live_numbered': '%{name} แผนภูมิ (%{number})',
	'one_unknown_live': 'แผนภูมิ',
	'one_unknown_live_numbered': 'แผนภูมิ (%{number})',
	'few_live': 'กลุ่มของ %{count} แผนภูมิ',
	'many_live': 'กลุ่มของ %{count} แผนภูมิ',
	'one_custom': 'วิดเจ็ตแบบกำหนดเอง',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} ตัวกรอง',
	'one_named_filter_numbered': '%{name} ตัวกรอง (%{number})',
	'one_unknown_filter': 'ตัวกรอง',
	'one_unknown_filter_numbered': 'ตัวกรอง (%{number})',
	'few_filter': 'กลุ่มของ %{count} ตัวกรอง',
	'many_filter': 'กลุ่มของ %{count} ตัวกรอง',
	'LIVE_bar_has_mapping': '%{values} แผนภูมิแท่ง',
	'LIVE_bar_has_mapping_numbered': '%{values} แผนภูมิแท่ง (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} เทียบกับ %{values} แผนภูมิแท่ง',
	'LIVE_bar_opt_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิแท่ง (%{number})',
	'LIVE_bar_no_mapping': 'แผนภูมิแท่งว่าง',
	'LIVE_bar_no_mapping_numbered': 'แผนภูมิแท่งว่าง (%{number})',
	'LIVE_bar_named': '%{name} แผนภูมิแท่ง',
	'LIVE_bar_named_numbered': '%{name} แผนภูมิแท่ง (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} แผนภูมิแท่งแบบสแต็ก',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} แผนภูมิแท่งแบบสแต็ก (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} เทียบกับ %{values} แผนภูมิแบบสแต็ก',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิแท่งแบบสแต็ก (%{number})',
	'LIVE_stacked_bar_no_mapping': 'แผนภูมิแท่งแบบสแต็กว่าง',
	'LIVE_stacked_bar_no_mapping_numbered': 'แผนภูมิแท่งแบบสแต็ก (%{number})',
	'LIVE_stacked_bar_named': '%{name} แผนภูมิแท่งแบบแสต็ก',
	'LIVE_stacked_bar_named_numbered': '%{name} แผนภูมิแท่งแบบแสต็ก (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} เทียบกับ %{x} และ %{y} แผนภูมิบับเบิล',
	'LIVE_bubble_has_mapping_numbered': '%{categories} เทียบกับ %{x} และ %{y} แผนภูมิบับเบิล (%{number})',
	'LIVE_bubble_no_mapping': 'แผนภูมิบับเบิลว่าง',
	'LIVE_bubble_no_mapping_numbered': 'แผนภูมิบับเบิลว่าง (%{number})',
	'LIVE_bubble_named': '%{name} แผนภูมิบับเบิล',
	'LIVE_bubble_named_numbered': '%{name} แผนภูมิบับเบิล (%{number})',
	'LIVE_composite_has_mapping': '%{categories} เทียบกับ %{columnValue} และ %{lineValue} แผนภูมิคอมโพสิต',
	'LIVE_composite_has_mapping_numbered': '%{categories} เทียบกับ %{columnValue} และ %{lineValue} แผนภูมิคอมโพสิต (%{number})',
	'LIVE_composite_no_mapping': 'แผนภูมิคอมโพสิตว่าง',
	'LIVE_composite_no_mapping_numbered': 'แผนภูมิคอมโพสิตว่าง (%{number})',
	'LIVE_composite_named': '%{name} แผนภูมิคอมโพสิต',
	'LIVE_composite_named_numbered': '%{name} แผนภูมิคอมโพสิต (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} แผนผังการตัดสินใจ',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} แผนผังการตัดสินใจ (%{number})',
	'LIVE_decision_tree_no_mapping': 'แผนผังการตัดสินใจว่าง',
	'LIVE_decision_tree_no_mapping_numbered': 'แผนผังการตัดสินใจว่าง (%{number})',
	'LIVE_decision_tree_named': '%{name} แผนผังการตัดสินใจ',
	'LIVE_decision_tree_named_numbered': '%{name} แผนผังการตัดสินใจ (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} แผนผังบับเบิลแบบแพ็ก',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} แผนผังบับเบิลแบบแพ็ก (%{number})',
	'LIVE_packed_bubble_no_mapping': 'แผนภูมิบับเบิลแบบแพ็กว่าง',
	'LIVE_packed_bubble_no_mapping_numbered': 'แผนภูมิบับเบิลแบบแพ็กว่าง (%{number})',
	'LIVE_packed_bubble_named': '%{name} แผนภูมิบับเบิลแบบแพ็ก',
	'LIVE_packed_bubble_named_numbered': '%{name} แผนภูมิบับเบิลแบบแพ็ก (%{number})',
	'LIVE_pie_has_mapping': '%{categories} เทียบกับ %{values} แผนภูมิวงกลม',
	'LIVE_pie_has_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิวงกลม (%{number})',
	'LIVE_pie_no_mapping': 'แผนภูมิวงกลมว่างเปล่า',
	'LIVE_pie_no_mapping_numbered': 'แผนภูมิวงกลมว่าง (%{number})',
	'LIVE_pie_named': '%{name} แผนภูมิวงกลม',
	'LIVE_pie_named_numbered': '%{name} แผนภูมิวงกลม (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} เทียบกับ %{values} แผนภูมิโดนัท',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิโดนัท (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'แผนภูมิโดนัทว่าง',
	'LIVE_pie_as_donut_no_mapping_numbered': 'แผนภูมิโดนัทว่าง (%{number})',
	'LIVE_pie_as_donut_named': '%{name} แผนภูมิโดนัท',
	'LIVE_pie_as_donut_named_numbered': '%{name} แผนภูมิโดนัท (%{number})',
	'LIVE_line_has_mapping': '%{categories} เทียบกับ %{values} แผนภูมิเส้น',
	'LIVE_line_has_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิเส้น (%{number})',
	'LIVE_line_no_mapping': 'แผนภูมิเส้นว่าง',
	'LIVE_line_no_mapping_numbered': 'แผนภูมิเส้นว่าง (%{number})',
	'LIVE_line_named': '%{name} แผนภูมิเส้น',
	'LIVE_line_named_numbered': '%{name} แผนภูมิเส้น (%{number})',
	'LIVE_area_has_mapping': '%{categories} เทียบกับ %{values} แผนภูมิพื้นที่',
	'LIVE_area_has_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิพื้นที่ (%{number})',
	'LIVE_area_no_mapping': 'แผนภูมิพื้นที่ว่าง',
	'LIVE_area_no_mapping_numbered': 'แผนภูมิพื้นที่ว่าง (%{number})',
	'LIVE_area_named': '%{name} แผนภูมิพื้นที่',
	'LIVE_area_named_numbered': '%{name} แผนภูมิพื้นที่ (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} เทียบกับ %{values} แผนภูมิพื้นที่เปอร์เซ็นต์แบบสแต็ก',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิพื้นที่เปอร์เซ็นต์แบบสแต็ก (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'แผนภูมิพื้นที่เปอร์เซ็นต์แบบสแต็กว่าง',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'แผนภูมิพื้นที่เปอร์เซ็นต์แบบสแต็กว่าง (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} แผนภูมิพื้นที่เปอร์เซ็นต์แบบสแต็ก',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} แผนภูมิพื้นที่เปอร์เซ็นต์แบบสแต็ก (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} แม็พความร้อน',
	'LIVE_heatmap_has_mapping_numbered': '%{color} แม็พความร้อน (%{number})',
	'LIVE_heatmap_no_mapping': 'แม็พความร้อนว่าง',
	'LIVE_heatmap_no_mapping_numbered': 'แม็พความร้อนว่าง (%{number})',
	'LIVE_heatmap_named': '%{name} แม็พความร้อน',
	'LIVE_heatmap_named_numbered': '%{name} แม็พความร้อน (%{number})',
	'LIVE_network_opt_mapping': '%{categories} เทียบกับ %{series} และ %{values} เครือข่าย',
	'LIVE_network_opt_mapping_numbered': '%{categories} เทียบกับ %{series} และ %{values} เครือข่าย (%{number})',
	'LIVE_network_has_mapping': '%{categories} เทียบกับ %{series} เครือข่าย',
	'LIVE_network_has_mapping_numbered': '%{categories} เทียบกับ %{series} เครือข่าย (%{number})',
	'LIVE_network_no_mapping': 'เครือข่ายว่าง',
	'LIVE_network_no_mapping_numbered': 'เครือข่ายว่าง (%{number})',
	'LIVE_network_named': '%{name} เครือข่าย',
	'LIVE_network_named_numbered': '%{name} เครือข่าย (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} เทียบกับ %{values} แผนภูมิแท่งแบบ radial',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิแท่งแบบ radial (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} แผนภูมิแท่งแบบ radial',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} แผนภูมิแท่งแบบ radial (%{number})',
	'LIVE_radial_bar_no_mapping': 'แผนภูมิแท่งแบบ radial ว่าง',
	'LIVE_radial_bar_no_mapping_numbered': 'แผนภูมิแท่งแบบ radial ว่าง (%{number})',
	'LIVE_radial_bar_named': '%{name} แผนภูมิแท่งแบบ radial',
	'LIVE_radial_bar_named_numbered': '%{name} แผนภูมิแท่งแบบ radial (%{number})',
	'LIVE_spiral_has_mapping': '%{values} แผนภูมิเกลียว',
	'LIVE_spiral_has_mapping_numbered': '%{values} แผนภูมิเกลียว (%{number})',
	'LIVE_spiral_no_mapping': 'แผนภูมิเกลียวว่าง',
	'LIVE_spiral_no_mapping_numbered': 'แผนภูมิเกลียวว่าง (%{number})',
	'LIVE_spiral_named': '%{name} แผนภูมิเกลียว',
	'LIVE_spiral_named_numbered': '%{name} แผนภูมิเกลียว (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} เทียบกับ %{size} แม็พแผนผัง',
	'LIVE_treemap_has_mapping_numbered': '%{categories} เทียบกับ %{size} แม็พแผนผัง (%{number})',
	'LIVE_treemap_no_mapping': 'แม็พแผนผังว่าง',
	'LIVE_treemap_no_mapping_numbered': 'แม็พแผนผังว่าง (%{number})',
	'LIVE_treemap_named': '%{name} แม็พแผนผัง',
	'LIVE_treemap_named_numbered': '%{name} แม็พแผนผัง (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} word cloud',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} word cloud (%{number})',
	'LIVE_wordcloud_no_mapping': 'word cloud ว่าง',
	'LIVE_wordcloud_no_mapping_numbered': 'word cloud ว่าง (%{number})',
	'LIVE_wordcloud_named': '%{name} word cloud',
	'LIVE_wordcloud_named_numbered': '%{name} word cloud (%{number})',
	'LIVE_data_player_has_mapping': '%{category} เครื่องเล่นข้อมูล',
	'LIVE_data_player_has_mapping_numbered': '%{category} เครื่องเล่นข้อมูล (%{number})',
	'LIVE_data_player_no_mapping': 'เครื่องเล่นข้อมูลว่าง',
	'LIVE_data_player_no_mapping_numbered': 'เครื่องเล่นข้อมูลว่าง (%{number})',
	'LIVE_data_player_named': '%{name} เครื่องเล่นข้อมูล',
	'LIVE_data_player_named_numbered': '%{name} เครื่องเล่นข้อมูล (%{number})',
	'LIVE_map_has_mapping': '%{locations} แม็พ',
	'LIVE_map_has_mapping_numbered': '%{locations} แม็พ (%{number})',
	'LIVE_map_no_mapping': 'แม็พว่าง',
	'LIVE_map_no_mapping_numbered': 'แม็พว่าง (%{number})',
	'LIVE_map_named': '%{name} แม็พ',
	'LIVE_map_named_numbered': '%{name} แม็พ (%{number})',
	'LIVE_point_has_mapping': '%{categories} เทียบกับ %{values} แผนภูมิจุด',
	'LIVE_point_has_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิจุด (%{number})',
	'LIVE_point_no_mapping': 'แผนภูมิจุดว่าง',
	'LIVE_point_no_mapping_numbered': 'แผนภูมิจุดว่าง (%{number})',
	'LIVE_point_named': '%{name} แผนภูมิจุด',
	'LIVE_point_named_numbered': '%{name} แผนภูมิจุด (%{number})',
	'LIVE_column_has_mapping': '%{values} แผนภูมิคอลัมน์',
	'LIVE_column_has_mapping_numbered': '%{values} แผนภูมิคอลัมน์ (%{number})',
	'LIVE_column_opt_mapping': '%{categories} เทียบกับ %{values} แผนภูมิคอลัมน์',
	'LIVE_column_opt_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิคอลัมน์ (%{number})',
	'LIVE_column_no_mapping': 'แผนภูมิคอลัมน์ว่าง',
	'LIVE_column_no_mapping_numbered': 'แผนภูมิคอลัมน์ว่าง (%{number})',
	'LIVE_column_named': '%{name} แผนภูมิคอลัมน์',
	'LIVE_column_named_numbered': '%{name} แผนภูมิคอลัมน์ (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} แผนภูมิคอลัมน์แบบสแต็ก',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} แผนภูมิคอลัมน์แบบสแต็ก (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} เทียบกับ %{values} แผนภูมิคอลัมน์แบบสแต็ก',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิคอลัมน์แบบสแต็ก (%{number})',
	'LIVE_stacked_column_no_mapping': 'แผนภูมิคอลัมน์แบบสแต็กว่าง',
	'LIVE_stacked_column_no_mapping_numbered': 'แผนภูมิคอลัมน์แบบสแต็กว่าง (%{number})',
	'LIVE_stacked_column_named': '%{name} แผนภูมิคอลัมน์แบบสแต็ก',
	'LIVE_stacked_column_named_numbered': '%{name} แผนภูมิคอลัมน์แบบสแต็ก (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} เทียบกับ %{x} และ %{y} พล็อตแบบกระจาย',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} เทียบกับ %{x} และ %{y} พล็อตแบบกระจาย (%{number})',
	'LIVE_scatter_has_mapping': '%{x} vs %{y} พล็อตแบบกระจาย',
	'LIVE_scatter_has_mapping_numbered': '%{x} vs %{y} พล็อตแบบกระจาย (%{number})',
	'LIVE_scatter_no_mapping': 'พล็อตแบบกระจายว่าง',
	'LIVE_scatter_no_mapping_numbered': 'พล็อตแบบกระจายว่าง (%{number})',
	'LIVE_scatter_named': '%{name} พล็อตแบบกระจาย',
	'LIVE_scatter_named_numbered': '%{name} พล็อตแบบกระจาย (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} แผนภูมิน้ำตกt',
	'LIVE_waterfall_has_mapping_numbered': '%{values} แผนภูมิน้ำตก (%{number})',
	'LIVE_waterfall_no_mapping': 'แผนภูมิน้ำตกว่างt',
	'LIVE_waterfall_no_mapping_numbered': 'แผนภูมิน้ำตกว่าง (%{number})',
	'LIVE_waterfall_named': '%{name} แผนภูมิน้ำตกt',
	'LIVE_waterfall_named_numbered': '%{name} แผนภูมิน้ำตก (%{number})',
	'LIVE_empty_visualization_hint_title': 'บิลด์วิชวลไลเซชันของคุณ',
	'LIVE_empty_visualization_hint_description': 'ลากและปล่อยคอลัมน์ที่นี่หรือปล่อยลงบนสล็อตทางด้านซ้าย',
	'LIVE_slots_required_field_description': '%{asterisk} ระบุฟิลด์ที่จำเป็น',
	'LIVE_slots_drag_and_drop_description': 'ลากและปล่อยข้อมูลลงในสล็อตที่อยู่ด้านบน เพื่อบิลด์และกรองวิชวลไลเซชัน',
	'requiredField': 'ฟิลด์ที่ต้องการ',
	'fullScreenEnter': 'ป้อนสู่การแสดงแบบเต็มหน้าจอ',
	'fullScreenClose': 'ออกจากการแสดงแบบเต็มหน้าจอ',
	'noExtraText_multipurpose': 'จุดยึดเอนกประสงค์',
	'noExtraText_multipurpose_numbered': 'จุดยึดอเนกประสงค์ (%{number})',
	'one_placeholder_vis': 'จุดยึดวิชวลไลเซชัน',
	'one_placeholder_vis_numbered': 'จุดยึดวิชวลไลเซชัน (%{number})',
	'one_placeholder_text': 'จุดยึดข้อความ',
	'one_placeholder_text_numbered': 'จุดยึดข้อความ (%{number})',
	'few_placeholder_text': 'กลุ่มของ %{count} จุดยึดข้อความ',
	'many_placeholder_text': 'กลุ่มของ %{count} จุดยึดข้อความ',
	'filter_includesAll': 'รวมทั้งหมด',
	'timeline_filter_moved_to': 'ตัวกรองเส้นเวลา %{id} ย้ายไปยัง %{time}',
	'timelineSettingsButton': 'อ็อพชันการเล่นกลับ',
	'autoPlay': 'เล่นฉากทั้งหมด',
	'loop': 'ลูป',
	'noSceneTransitionLabel': 'ไม่มี',
	'sceneTransitionPropertyLabel': 'การเปลี่ยนฉาก',
	'animatedPathSceneTransitionLabel': 'พาธเคลื่อนไหว',
	'sweepSceneTransitionLabel': 'ปัด',
	'propAniAnimation': 'แอนิเมชัน',
	'propAniTypeEntrance': 'แอนิเมชันทางเข้า',
	'propAniDirectionIn': 'ทิศทางของทางเข้า',
	'propAniTypeExit': 'แอนิเมชันทางออก',
	'propAniDirectionOut': 'ทิศทางของทางออก',
	'propAniDirection': 'ทิศทาง',
	'timelineAnimationProperties': 'เปิดคุณสมบัติภาพเคลื่อนไหว',
	'editStoryCoachMarkTitle': 'แก้ไขเรื่อง',
	'editStoryCoachMarkContents': 'คลิกที่ไอคอนรูปดินสอเพื่อแก้ไขเรื่องนี้',
	'addDataStoryCoachMarkContents': 'ลากและปล่อยจากพาเนลข้อมูลลงบนเรื่องของคุณ',
	'expandSceneCoachmarkTitle': 'เปิดเส้นเวลา',
	'expandSceneCoachmarkContents': 'แสดงภาพเคลื่อนไหวของฉากโดยการปรับการแสดงอ็อบเจ็กต์ตามเวลาและระยะเวลา',
	'overviewCoachmarkTitle': 'ฉากภาพรวม',
	'overviewCoachmarkContents': 'ใช้ฉากภาพรวมที่จุดเริ่มต้นและจุดสิ้นสุดของเรื่องเพื่อแสดงภาพใหญ่ของฉากทั้งหมด จากฉากภาพรวม คลิกและลากฉากเพื่อปัดไปเป็นฉากอื่น คุณสามารถแสดงหรือซ่อนฉากภาพรวมในคุณสมบัติเรื่อง',
	'animatedPathCoachmarkTitle': 'พาธเคลื่อนไหว',
	'animatedPathCoachmarkContents': 'เมื่อต้องการทำให้อ็อบเจ็กต์เคลื่อนไหวจากฉากหนึ่งไปยังอีกฉากหนึ่ง ให้ทำซ้ำฉากด้วยอ็อบเจ็กต์ จากนั้น ย้าย ปรับขนาด หรือหมุนอ็อบเจ็กต์ที่ทำซ้ำบนฉากใหม่',
	'tabName_animation': 'แอนิเมชัน',
	'textWidgetIconPlaceholderText': 'คลิกเพื่อเพิ่มข้อความ',
	'buildVisHeader': 'สร้างวิชวลไลเซชัน',
	'visIconPlaceholderText': 'ลากและปล่อยฟิลด์เพื่อสร้างวิชวลไลเซชัน',
	'launchNewExplore': 'การสำรวจใหม่',
	'addTo': 'เพิ่มไปยัง',
	'addToExisting': 'กำลังเพิ่มเข้ากับที่มีอยู่แล้ว...',
	'exploreData': 'สำรวจ',
	'explore_remove_widget_styles': 'คุณสมบัติวิชวลไลเซชันที่กำหนดเอง เช่น การตั้งค่าสีจะไม่คงอยู่ในการสำรวจของคุณ',
	'editNotebook': 'แก้ไขวิดเจ็ต',
	'thumbnails_error_fetching': 'เกิดข้อผิดพลาดขณะเรียกข้อมูลภาพขนาดย่อ',
	'copy': '%{count} สินทรัพย์ที่คัดลอก',
	'specConvertErr': 'เกิดข้อผิดพลาดขณะวางหรือแปลงข้อมูลจำเพาะแดชบอร์ด',
	'specCopyErr': 'เกิดข้อผิดพลาดขณะคัดลอกข้อมูลจำเพาะคลิปบอร์ด',
	'pasteNotSupportedErr': 'ไม่สนับสนุนการวางจาก %{name}',
	'reportParam': 'รายงาน',
	'filterWidgetCopyWarn': 'ไม่มีการคัดลอกวิชวลไลเซชันตัวกรอง เนื่องจากไม่สนับสนุนตัวกรองในขณะนี้',
	'upgradingDashboard': 'การอัพเดต "%{name}" สำหรับ %{version}...',
	'upgradeComplete': 'อัพเกรดเสร็จสมบูรณ์',
	'individualTabProperties': 'คุณสมบัติแท็บแต่ละคุณสมบัติ',
	'propMasterTabStylesLabel': 'การกำหนดสไตล์แท็บมาสเตอร์',
	'propTabPosition': 'ตำแหน่งแท็บ',
	'propTabTitle': 'หัวเรื่อง',
	'propTabBackgroundColor': 'เติมสี',
	'propTabTextColor': 'สีหัวเรื่อง',
	'propTabSelectedBarColor': 'สีแถบที่เลือก',
	'propTabRestoreDefaults': 'เรียกคืนค่าดีฟอลต์',
	'propIndividualTabStylesLabel': 'การกำหนดสไตล์แท็บแต่ละแท็บ',
	'propIndividualTabStylesAriaLabel': 'เปิดคุณสมบัติการกำหนดสไตล์แท็บแต่ละแท็บ',
	'propTabIconPosition': 'ตำแหน่งไอคอน',
	'propLeftTitle': 'ด้านซ้ายของหัวเรื่อง',
	'propRightTitle': 'ด้านขวาของหัวเรื่อง',
	'propTopTitle': 'ด้านบนหัวเรื่อง',
	'propBottomTitle': 'ด้านล่างหัวเรื่อง',
	'propTabIconLabel': 'วิชวล',
	'propTabIcon': 'ไอคอน',
	'propTabIconColor': 'สีไอคอน',
	'no_icon': 'ว่าง',
	'announcement': 'ประกาศ',
	'api': 'Api',
	'archive': 'เก็บแบบถาวร',
	'asset': 'สิาทรัพย์',
	'attachment': 'สิ่งที่แนบ',
	'audio': 'เสียง',
	'bee': 'ผึ้ง',
	'blog': 'บล็อก',
	'bookmark': 'บุ๊กมาร์ก',
	'calendar': 'ปฏิทิน',
	'camera': 'กล้อง',
	'capability': 'ความสามารถ',
	'catalog': 'แค็ตตาล็อก',
	'chat_message': 'ข้อความแชท',
	'checkout_cart': 'เช็กเอาต์รถเข็น',
	'client': 'ไคลเอ็นต์',
	'clock': 'นาฬิกา',
	'cloud': 'เมฆ',
	'code': 'โค้ด',
	'data_quality': 'คุณภาพของข้อมูล',
	'folder': 'โฟลเดอร์',
	'forum': 'ฟอรัม',
	'glasses': 'แว่นตา',
	'group': 'กลุ่ม',
	'hat': 'หมวก',
	'headphone': 'หูฟัง',
	'hills': 'ทิวเขา',
	'home': 'โฮม',
	'idea': 'แนวคิด',
	'image': 'อิมเมจ',
	'inventory': 'สินค้าคงคลัง',
	'like': 'ถูกใจ',
	'link': 'ลิงก์',
	'location': 'ที่ตั้ง',
	'manage': 'จัดการ',
	'pen': 'ปากกา',
	'mobile_phone': 'โทรศัพท์มือถือ',
	'music': 'เพลง',
	'notifications': 'การแจ้งเตือน',
	'paint': 'ทาสี',
	'payment': 'การชำระเงิน',
	'password_key': 'คีย์รหัสผ่าน',
	'people': 'ผู้คน',
	'person': 'บุคคล',
	'phone': 'โทรศัพท์',
	'pin': 'ปักหมุด',
	'print': 'พิมพ์',
	'recording': 'กำลังบันทึก',
	'repository': 'ที่เก็บ',
	'role': 'บทบาท',
	'search': 'ค้นหา',
	'properties': 'คุณสมบัติ',
	'speaker': 'ผู้บรรยาย',
	'star': 'ดาว',
	'tag': 'แท็ก',
	'thumbs_up': 'หัวแม่โป้งชี้ลง',
	'thumbs_down': 'หัวแม่โป้งชี้ลง',
	'tools': 'เครื่องมือ',
	'traffic': 'ทราฟฟิก',
	'trash': 'ถังขยะ',
	'twitter': 'Twitter',
	'unknown': 'ไม่รู้จัก',
	'user': 'ผู้ใช้',
	'venn_diagram': 'ไดอะแกรมเวนน์',
	'video': 'วิดีโอ',
	'view': 'มุมมอง',
	'warning': 'คำเตือน',
	'watch': 'เฝ้าดู',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'เวิร์กสเปซ',
	'world': 'โลก',
	'OnLoadFilterModifierDatasourceMismatch': 'ตัวกรองจะไม่สามารถใช้กับเป้าหมายเนื่องจากแดชบอร์ดกำลังใช้แหล่งข้อมูลอื่น',
	'OnLoadFilterModifierColumnMismatch': 'ไม่ได้ใช้ตัวกรองอย่างน้อยหนึ่งตัวเนื่องจากไม่พบคอลัมน์ที่ตรงกัน',
	'eventGroupButtonLabel': 'ดูการเชื่อมต่อวิดเจ็ต',
	'dockToolbar': 'ยึดแถบเครื่องมือ',
	'undockToolbar': 'ปลดแถบเครื่องมือ',
	'propShowTitle': 'แสดงหัวเรื่อง'
});
